import { LoadableAfterPaint } from '@confluence/loadable';

export const BlogPostsMacroHandler = LoadableAfterPaint({
	loader: async () =>
		(
			await import(
				/* webpackChunkName: "loadable-BlogPostsMacro" */ '../src/BlogPostsMacroRenderer.tsx'
			)
		).BlogPostsMacroRenderer,
});
